// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1s6RgMAGgfzWoz {\n  color: #CF513D;\n  padding-left: 2px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createTeamLabelstar": "_1s6RgMAGgfzWoz"
};
export default ___CSS_LOADER_EXPORT___;
